import * as TrayTaskConstants from './TrayTaskConstants';

function hasTaskFailed(task) {
  return task.progress === TrayTaskConstants.FAILURE_PROGRESS;
}

function hasTaskSucceeded(task) {
  return task.progress === TrayTaskConstants.SUCCESS_PROGRESS;
}

function hasTaskFinished(task) {
  return hasTaskFailed(task) || hasTaskSucceeded(task);
}

export {hasTaskFailed, hasTaskSucceeded, hasTaskFinished};
